'use client';

import { useEffect } from 'react';
import { HeaderSponsorProps } from './siteNav.types';
import { useHeaderSponsors } from './headerSponsorContext';

const HeaderSponsorSetter = ({
  sponsors,
}: {
  sponsors: HeaderSponsorProps[];
}) => {
  const { setSponsors } = useHeaderSponsors();

  useEffect(() => {
    setSponsors(sponsors);
    return () => setSponsors([]);
  }, [sponsors, setSponsors]);

  return null;
};

export default HeaderSponsorSetter;
